
riot.tag2('current-time', '  <p class="navbar-text">{timer}</p>\n', '', '', function(opts) {
"use strict";

var self = this;

self.timer = '';

self.time = function () {
    var options = {
        timeZone: "Europe/Moscow",
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    },
        formatter = new Intl.DateTimeFormat([], options);
    var date_ = new Date(Date.now());

    self.timer = formatter.format(date_);

    self.update();
};

setInterval(self.time, 1000);
});


// WEBPACK FOOTER //
// ./components/current-time.tag